import { ConfirmDialog } from "@/components/ui/ConfirmDialog";
import { AlertTriangle, Trash2 } from "lucide-react";
import React from "react";

import type { DeleteDetailConfirm, VisitDisplay } from "./types";

interface DeleteConfirmModalsProps {
  showDeleteConfirm: DeleteDetailConfirm | null;
  setShowDeleteConfirm: (v: DeleteDetailConfirm | null) => void;
  confirmDeleteDetail: () => void;
  showDeleteVisitConfirm: VisitDisplay | null;
  setShowDeleteVisitConfirm: (v: VisitDisplay | null) => void;
  confirmDeleteVisit: () => void;
  bulkDeleteVisitIds: string[] | null;
  setBulkDeleteVisitIds: (ids: string[] | null) => void;
  confirmBulkDeleteVisits: () => void;
  isBulkDeletingVisits?: boolean;
}

export const DeleteConfirmModals: React.FC<DeleteConfirmModalsProps> = ({
  showDeleteConfirm,
  setShowDeleteConfirm,
  confirmDeleteDetail,
  showDeleteVisitConfirm,
  setShowDeleteVisitConfirm,
  confirmDeleteVisit,
  bulkDeleteVisitIds,
  setBulkDeleteVisitIds,
  confirmBulkDeleteVisits,
  isBulkDeletingVisits = false,
}) => {
  const bulkCount = bulkDeleteVisitIds?.length ?? 0;

  return (
    <>
      <ConfirmDialog
        open={showDeleteConfirm !== null}
        onOpenChange={(open) => {
          if (!open) setShowDeleteConfirm(null);
        }}
        variant="destructive"
        icon={AlertTriangle}
        title="Delete Detail"
        description={
          <>
            Are you sure you want to delete this detail? This action cannot be undone and will
            remove the information from this visit.
          </>
        }
        confirmLabel="Delete Detail"
        confirmIcon={Trash2}
        onConfirm={confirmDeleteDetail}
      />

      <ConfirmDialog
        open={showDeleteVisitConfirm !== null}
        onOpenChange={(open) => {
          if (!open) setShowDeleteVisitConfirm(null);
        }}
        variant="destructive"
        icon={Trash2}
        title="Delete Entire Visit"
        description={
          <>
            You are about to delete this entire visit and all associated details. This action is
            irreversible.
          </>
        }
        confirmLabel="Confirm Delete"
        confirmIcon={Trash2}
        onConfirm={confirmDeleteVisit}
      />

      <ConfirmDialog
        open={bulkCount > 0}
        onOpenChange={(open) => {
          if (!open) setBulkDeleteVisitIds(null);
        }}
        variant="destructive"
        icon={Trash2}
        title="Delete selected visits"
        description={
          <>
            You are about to delete {bulkCount} visit{bulkCount !== 1 ? "s" : ""} and all associated
            details. This action cannot be undone.
          </>
        }
        confirmLabel="Delete visits"
        confirmIcon={Trash2}
        onConfirm={confirmBulkDeleteVisits}
        isConfirming={isBulkDeletingVisits}
      />
    </>
  );
};
